webpackJsonp([224494088270459],{

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var location = function location() {
	  if (typeof document !== 'undefined') {
	    return document.location;
	  } else {
	    return 'https://urbanize.at';
	  }
	};
	
	exports.default = function () {
	  return _react2.default.createElement(
	    'div',
	    { className: 'add-this' },
	    _react2.default.createElement(
	      'a',
	      { onClick: function onClick() {
	          window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(location()), 'facebook-share-dialog', 'width=626,height=436');
	        },
	        title: 'Auf Facebook teilen' },
	      _react2.default.createElement('span', { className: 'icon-facebook' })
	    ),
	    _react2.default.createElement(
	      'a',
	      { onClick: function onClick() {
	          window.open('https://twitter.com/share?url=' + location(), 'twitter-share-dialog', 'width=626,height=436');
	        },
	        title: 'Auf Twitter teilen' },
	      _react2.default.createElement('span', { className: 'icon-twitter' })
	    ),
	    _react2.default.createElement(
	      'a',
	      { onClick: function onClick() {
	          return window.print();
	        },
	        title: 'Seite drucken' },
	      _react2.default.createElement('span', { className: 'icon-print' })
	    ),
	    _react2.default.createElement(
	      'a',
	      { href: 'mailto:?subject=Urbanize Festival&body=' + location(),
	        title: 'Per Email versenden' },
	      _react2.default.createElement('span', { className: 'icon-mail' })
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var categories = _ref.categories;
	
	  if (categories.length === 0) {
	    return null;
	  }
	
	  return _react2.default.createElement(
	    'p',
	    null,
	    'KATEGORIEN',
	    _react2.default.createElement('br', null),
	    categories.map(function (category, index) {
	      return _react2.default.createElement(
	        'span',
	        { key: category },
	        index > 0 ? ', ' : null,
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/category/' + category + '/' },
	          category
	        )
	      );
	    })
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var tags = _ref.tags;
	
	  if (tags.length === 0) {
	    return null;
	  }
	
	  return _react2.default.createElement(
	    'p',
	    null,
	    'TAGS',
	    _react2.default.createElement('br', null),
	    tags.map(function (tag, index) {
	      return _react2.default.createElement(
	        'span',
	        { key: tag },
	        index > 0 ? ', ' : null,
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/tag/' + tag + '/' },
	          tag
	        )
	      );
	    })
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = exports.fragments = undefined;
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _addThis = __webpack_require__(200);
	
	var _addThis2 = _interopRequireDefault(_addThis);
	
	var _categories = __webpack_require__(201);
	
	var _categories2 = _interopRequireDefault(_categories);
	
	var _tags = __webpack_require__(204);
	
	var _tags2 = _interopRequireDefault(_tags);
	
	var _timeframe = __webpack_require__(128);
	
	var _timeframe2 = _interopRequireDefault(_timeframe);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var data = _ref.data,
	      pathContext = _ref.pathContext;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'breadcrumb' },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/' },
	        'Home'
	      ),
	      _react2.default.createElement(
	        'span',
	        null,
	        ' \u203A '
	      ),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/events/' },
	        'Programm'
	      ),
	      _react2.default.createElement(
	        'span',
	        null,
	        ' \u203A '
	      ),
	      data.eventsYaml.title
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'title' },
	      data.eventsYaml.title
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'subtitle' },
	      data.eventsYaml.subtitle
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'additional' },
	      _react2.default.createElement(_timeframe2.default, { event: data.eventsYaml }),
	      '\xA0',
	      data.eventsYaml.address
	    ),
	    _react2.default.createElement('div', { className: 'additional',
	      dangerouslySetInnerHTML: { __html: data.eventsYaml.fields.additional_infoHtml } }),
	    _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: data.eventsYaml.fields.abstractHtml } }),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: data.eventsYaml.fields.textHtml } }),
	    _react2.default.createElement('hr', null),
	    _react2.default.createElement(_categories2.default, { categories: data.eventsYaml.categories }),
	    _react2.default.createElement(_tags2.default, { tags: data.eventsYaml.tags }),
	    _react2.default.createElement(_addThis2.default, null)
	  );
	};
	
	var fragments = exports.fragments = '** extracted graphql fragment **';
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-event-js-9eb1e9b952dc221369c5.js